import { render, staticRenderFns } from "./TableSectionComponent.vue?vue&type=template&id=613fbc1b&"
import script from "./TableSectionComponent.vue?vue&type=script&lang=js&"
export * from "./TableSectionComponent.vue?vue&type=script&lang=js&"
import style0 from "./TableSectionComponent.vue?vue&type=style&index=0&id=613fbc1b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports